import Cookies from "js-cookie";

// App-specific cookie names. Browsers share cookies between every app on the same
// host (e.g. localhost:3000 admin + localhost:5051 customer), so generic names like
// "user"/"user_token" get overwritten by other apps built from the same template.
export const TOKEN_COOKIE = "expl_customer_token";
export const USER_COOKIE = "expl_customer_user";

const SessionManager = {
    // ---------------- COOKIES (Client-Readable) ----------------
    setCookie: (name, value, days = 1) => {
        Cookies.set(name, value, { expires: days / 24, path: "/" });
    },

    getCookie: (name) => {
        return Cookies.get(name);
    },

    removeCookie: (name) => {
        Cookies.remove(name, { path: "/" });
    },

    // ---------------- SESSION STORAGE ----------------
    setSession: (key, value) => {
        sessionStorage.setItem(key, JSON.stringify(value));
    },

    getSession: (key) => {
        const data = sessionStorage.getItem(key);
        try {
            return JSON.parse(data);
        } catch {
            return data;
        }
    },

    removeSession: (key) => {
        sessionStorage.removeItem(key);
    },

    clearSession: () => {
        sessionStorage.clear();
    },

    // ---------------- FULL LOGOUT ----------------
    // token + user cookies and all session storage
    clearAll: () => {
        Cookies.remove(TOKEN_COOKIE, { path: "/" });
        Cookies.remove(USER_COOKIE, { path: "/" });
        sessionStorage.clear();
    }
};

export default SessionManager;